import axiosInstance from '@/plugins/axios';

// Preferências de colunas visíveis por usuário/tabela (CON-5157).
const ServiceColumnPreferences = {
  get: (tableId) => axiosInstance.get(`column-preferences/${tableId}`),
  save: (tableId, hiddenColumns) =>
    axiosInstance.put(`column-preferences/${tableId}`, { hiddenColumns }),
};

export default ServiceColumnPreferences;
